import { Component, inject, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
  imports: [MatButtonModule],
})
export class ConfirmDialogComponent {
  public dialog = inject(MatDialogRef<ConfirmDialogComponent>);
  private data = inject(MAT_DIALOG_DATA) as {
    title: string;
    message: string;
    buttonConfirm: string;
    buttonCancel: string;
  };

  readonly title = signal(this.data.title);
  readonly message = signal(this.data.message);
  readonly buttonConfirm = signal(this.data.buttonConfirm);
  readonly buttonCancel = signal(this.data.buttonCancel);
}
